import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { Helmet } from "react-helmet";

import Header from "../Components/Header";
import Footer from "../Components/Footer";

const Section = ({ title, children }) => (
  <Box mb={4}>
    <Typography variant="h6" fontWeight="bold" gutterBottom>
      {title}
    </Typography>
    <Typography color="text.secondary" lineHeight={1.8}>
      {children}
    </Typography>
  </Box>
);

const TermsAndConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Terms & Conditions – GroHair & GloSkin</title>
        <meta
          name="description"
          content="Read the Terms & Conditions for using GroHair & GloSkin's website and booking our hair and skin care services."
        />
      </Helmet>

      <Header />

      <Box
        sx={{
          px: { xs: 2, sm: 4, md: 8, lg: 12 },
          py: 6,
          mt: { xs: 10, md: 10 },
          bgcolor: "#fff",
        }}
      >
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Terms & Conditions
        </Typography>
        <Typography color="text.secondary" mb={4}>
          Last updated: 29 August 2026
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Section title="1. Acceptance of Terms">
          By accessing or using the GroHair & GloSkin website or booking any
          of our services, you agree to be bound by these Terms &
          Conditions. If you do not agree with any part of these terms,
          please do not use our website or services.
        </Section>

        <Section title="2. Appointments & Consultations">
          Appointments booked through our website or by phone are subject to
          availability and confirmation by our team. We recommend arriving
          on time for your appointment; late arrivals may result in a
          shortened session or rescheduling.
        </Section>

        <Section title="3. Treatment Results">
          Hair and skin treatment outcomes vary from person to person based
          on individual conditions and adherence to recommended care.
          Information provided on this website is for general guidance only
          and does not constitute a guarantee of specific results.
        </Section>

        <Section title="4. Payments">
          Service charges are communicated at the time of consultation or
          booking. Payment terms, including any advance payment for
          treatments, will be explained by our clinic staff before you
          proceed.
        </Section>

        <Section title="5. Cancellations & Refunds">
          Cancellation and refund requests are handled in accordance with
          our Refund & Cancellation Policy, available on our website.
        </Section>

        <Section title="6. Website Use">
          You agree to use this website only for lawful purposes and in a
          manner that does not infringe the rights of, or restrict or
          inhibit the use of, this website by any third party.
        </Section>

        <Section title="7. Intellectual Property">
          All content on this website, including text, images, and logos, is
          the property of GroHair & GloSkin unless otherwise stated, and may
          not be reproduced without prior written consent.
        </Section>

        <Section title="8. Limitation of Liability">
          GroHair & GloSkin shall not be liable for any indirect, incidental,
          or consequential damages arising from the use of this website or
          our services, to the extent permitted by applicable law.
        </Section>

        <Section title="9. Changes to These Terms">
          We may revise these Terms & Conditions from time to time. Continued
          use of our website or services after changes are posted
          constitutes acceptance of the updated terms.
        </Section>

        <Section title="10. Contact Us">
          For questions about these Terms & Conditions, please contact us at
          Kanchipuram@adgrohair.com or call +91 097510 56789.
        </Section>
      </Box>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;
